export const BOOKING_SOURCE = {
  DASHBOARD: 'dashboard',
  SESSIONS: 'sessions',
  NAV: 'nav',
  TEST: 'test',
  RECOVERY: 'recovery',
  PACKAGES: 'packages',
}

export const BOOKING_ACTION = {
  START: 'start',
  RESUME: 'resume',
  SELECT_TIME: 'selectTime',
}

export const BOOKING_INTENT_QUERY_KEYS = ['source', 'action', 'therapistId', 'package_id', 'reffer_id']
